/* NEX cart picks: colour dots (own colours) + size chips side by side; the + slots open same-kind products right under their meter */
(function () {
'use strict';
var HEX = { black: '#151515', white: '#fff', offwhite: '#f4efe6', cream: '#f3ead3', beige: '#d9c3a0', sand: '#d8c39a', brown: '#6b4428', khaki: '#a89a6a', olive: '#6b6b2e', green: '#2f9a4f', mint: '#a8e6c6', navy: '#1c2a5a', blue: '#2f6fdb', sky: '#8cc8f5', red: '#d92b2b', burgundy: '#6e1630', maroon: '#6e1630', pink: '#f28bb8', purple: '#7a3fd0', lilac: '#c4a0f0', violet: '#7a3fd0', yellow: '#f5d530', orange: '#f28a1d', grey: '#9a9a9a', gray: '#9a9a9a', charcoal: '#3a3a3a', silver: '#c9c9c9', ice: '#cfe9ff', acid: '#c8ff3d', lime: '#c8ff3d', teal: '#1a8a8a', coral: '#f26b5b' };
var DATA = {};
var HANDLE = { tee: 'summer-tees', cap: 'vintage-washed-cap', hoodie: 'hoodies' }, NAME = { tee: 'summer tee', cap: 'cap', hoodie: 'hoodie' }, POOL = {};
var H0 = {
esc: function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; },
img: function (u, w) { if (!u) return ''; u = typeof u === 'string' ? u : (u.src || u.url || ''); return u ? u.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; },
money: function (c) { return 'EGP ' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
};
function hex(n) {
n = String(n || '').toLowerCase();
var keys = Object.keys(HEX);
for (var i = 0; i < keys.length; i++) if (n.indexOf(keys[i]) > -1) return HEX[keys[i]];
return '';
}
function optIndex(p, re) {
var o = p.options || [];
for (var i = 0; i < o.length; i++) { var n = typeof o[i] === 'string' ? o[i] : o[i].name; if (re.test(n || '')) return i + 1; }
return 0;
}
function uniq(a) { var s = {}; return a.filter(function (x) { return x != null && !s[x] && (s[x] = 1); }); }
function card(p, H) {
var isHd = /hoodie/i.test(p.type || p.product_type || '');
var v = (p.variants || []).filter(function (x) { return x.available && !(isHd && [x.option1, x.option2, x.option3].some(function (o) { return /^(2\s*xl|xxl)$/i.test(String(o || '').trim()); })); });
if (!v.length) return '';
var price = typeof p.price === 'number' ? p.price : Math.round(parseFloat(v[0].price) * 100);
var cmp = typeof p.compare_at_price === 'number' ? p.compare_at_price : Math.round(parseFloat(v[0].compare_at_price || 0) * 100);
if (!(cmp > price)) cmp = 0;
var src = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0]));
var ci = optIndex(p, /colou?r/i), si = optIndex(p, /size/i);
if (!si && !ci && v.length > 1) si = 1;
var head = '<div class="rc" data-rc="' + p.id + '"><a class="rc__img" href="/products/' + H.esc(p.handle) + '"><img src="' + H.esc(H.img(src, 300)) + '" alt="" loading="lazy"></a><p class="rc__t">' + H.esc(p.title) + '</p><p class="rc__p">' + H.money(price) + (cmp ? '<s>' + H.money(cmp) + '</s>' : '') + '</p>';
if (v.length === 1) return head + '<button type="button" class="rc__add" data-add-id="' + v[0].id + '">Add</button></div>';
var imgs = {};
(p.images || []).forEach(function (im) { (im.variant_ids || []).forEach(function (id) { imgs[id] = im.src; }); });
var vs = v.map(function (x) { return { id: x.id, c: ci ? x['option' + ci] : '', s: si ? x['option' + si] : '', i: (x.featured_image && x.featured_image.src) || imgs[x.id] || '' }; });
DATA[p.id] = { v: vs, H: H };
var cols = ci ? uniq(vs.map(function (x) { return x.c; })) : [], sizes = si ? uniq(vs.map(function (x) { return x.s; })) : [];
var cHtml = cols.map(function (c) {
var h = hex(c), first = vs.filter(function (x) { return x.c === c; })[0], bg = h ? 'background:' + h : (first && first.i ? 'background:url(' + H.img(first.i, 60) + ') center/cover' : 'background:#888');
return '<button type="button" class="ro__dot' + (h === '#fff' ? ' is-light' : '') + '" data-c="' + H.esc(c) + '" style="' + bg + '" title="' + H.esc(c) + '" aria-label="' + H.esc(c) + '"></button>';
}).join('');
var sHtml = sizes.map(function (s) { return '<button type="button" class="ro__sz" data-s="' + H.esc(s) + '">' + H.esc(s) + '</button>'; }).join('');
return head + '<button type="button" class="rc__add" data-opt-open>Add</button>' +
'<div class="rc__opt" hidden><button type="button" class="ro__x" data-opt-open aria-label="Close">×</button>' +
(cols.length ? '<p class="ro__l">Color <b data-cn></b></p><div class="ro__row ro__row--c">' + cHtml + '</div>' : '') +
(sizes.length ? '<p class="ro__l">Size</p><div class="ro__row">' + sHtml + '</div>' : '') +
'<button type="button" class="ro__go" data-opt-go disabled>Add to bag</button></div></div>';
}
function state(rc) {
var d = DATA[rc.getAttribute('data-rc')], c = rc.querySelector('.ro__dot.is-on'), s = rc.querySelector('.ro__sz.is-on');
var hasC = !!rc.querySelector('.ro__dot'), hasS = !!rc.querySelector('.ro__sz');
var cv = c ? c.getAttribute('data-c') : null, sv = s ? s.getAttribute('data-s') : null;
[].forEach.call(rc.querySelectorAll('.ro__sz'), function (b) {
var ok = d.v.some(function (x) { return (!hasC || !cv || x.c === cv) && x.s === b.getAttribute('data-s'); });
b.disabled = !ok; if (!ok && b.classList.contains('is-on')) { b.classList.remove('is-on'); sv = null; }
});
var m = d.v.filter(function (x) { return (!hasC || x.c === cv) && (!hasS || x.s === sv); })[0];
var go = rc.querySelector('.ro__go'); go.disabled = !(m && (!hasC || cv) && (!hasS || sv)); go.setAttribute('data-vid', m ? m.id : '');
var cn = rc.querySelector('[data-cn]'); if (cn) cn.textContent = cv || '';
}
/* + slot: show products of the same kind right under that meter */
function pick(pk) {
var key = pk.getAttribute('data-pick'), om = pk.closest('.om');
if (!om || !HANDLE[key]) return;
var old = om.nextElementSibling, same = old && old.classList.contains('om__pick') && old.getAttribute('data-k') === key;
[].forEach.call(document.querySelectorAll('.om__pick'), function (x) { x.parentNode.removeChild(x); });
if (same) return;
var box = document.createElement('div'); box.className = 'om__pick'; box.setAttribute('data-k', key);
box.innerHTML = '<p class="cd__h">Add a ' + NAME[key] + '</p><p class="cd__loading">Loading…</p>';
om.parentNode.insertBefore(box, om.nextSibling);
(POOL[key] ? Promise.resolve(POOL[key]) : fetch('/collections/' + HANDLE[key] + '/products.json?limit=250', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) { POOL[key] = d.products || []; return POOL[key]; }))
.then(function (list) {
var html = list.slice(0, 10).map(function (p) { return card(p, H0); }).join('');
box.innerHTML = '<p class="cd__h">Add a ' + NAME[key] + '</p>' + (html ? '<div class="rc-row">' + html + '</div>' : '<p class="cd__loading">Nothing available right now.</p>');
box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}).catch(function () { box.innerHTML = ''; });
}
function click(t, add) {
var pk = t.closest('[data-pick]');
if (pk) { pick(pk); return true; }
var rc = t.closest('[data-rc]');
if (!rc) return false;
if (t.closest('[data-opt-open]')) { var p = rc.querySelector('.rc__opt'); p.hidden = !p.hidden; return true; }
var dot = t.closest('.ro__dot');
if (dot) {
[].forEach.call(rc.querySelectorAll('.ro__dot'), function (b) { b.classList.toggle('is-on', b === dot); });
var d = DATA[rc.getAttribute('data-rc')], f = d.v.filter(function (x) { return x.c === dot.getAttribute('data-c') && x.i; })[0];
if (f) rc.querySelector('.rc__img img').src = d.H.img(f.i, 300);
state(rc); return true;
}
var sz = t.closest('.ro__sz');
if (sz) { if (!sz.disabled) { [].forEach.call(rc.querySelectorAll('.ro__sz'), function (b) { b.classList.toggle('is-on', b === sz); }); state(rc); } return true; }
var go = t.closest('[data-opt-go]');
if (go) { if (!go.disabled) add(go.getAttribute('data-vid'), go); return true; }
return false;
}
var PAY = '<div class="cd__pay" aria-label="Payment methods"><span class="pm"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 10v.01M18 14v.01"/></svg>Cash</span><span class="pm pm--visa">VISA</span><span class="pm pm--mc"><i></i><i></i></span>' +
'<span class="pm"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="14" rx="3"/><path d="M16 13h2M2 10h20M5 6l11-3 1 3"/></svg>Wallets</span>' +
'<span class="pm"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="3"/><path d="M2 10h20M6 15h4"/></svg>Installments</span></div>' +
'<p class="cd__fw">Secured by <b>Fawaterk</b> • Cash on delivery also available</p>';
var LOCK = '<svg class="cd__lock" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="3"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
/* bundle boxes: the small x on a picked item takes that one item out right away */
document.addEventListener('click', function (e) {
var rm = e.target.closest && e.target.closest('[data-unit-rm]');
if (!rm) return;
var sl = rm.closest('[data-unit]'); if (!sl) return;
e.preventDefault(); e.stopPropagation();
var key = sl.getAttribute('data-unit'); sl.classList.add('is-busy');
fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
var it = (c.items || []).filter(function (x) { return x.key === key; })[0]; if (!it) return;
return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, it.quantity - 1) }) });
}).then(function () { if (window.NexCart) return window.NexCart.refresh(); }).catch(function () { sl.classList.remove('is-busy'); });
}, true);
/* Docker hats: when the cap picker opens (home bundles or bag), add a separate row under the caps with EVERY colour as its own card */
var DK = null;
function dkList() {
if (DK) return Promise.resolve(DK);
return fetch('/collections/hats/products.json?limit=24', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) { DK = d.products || []; return DK; }).catch(function () { DK = []; return DK; });
}
function dkCards(l) {
var out = [];
l.forEach(function (p) {
var ci = optIndex(p, /colou?r/i);
if (!ci || (p.variants || []).length < 2) { out.push(card(p, H0)); return; }
var imgs = {};
(p.images || []).forEach(function (im) { (im.variant_ids || []).forEach(function (id) { imgs[id] = im.src; }); });
(p.variants || []).forEach(function (x) {
var src = (x.featured_image && x.featured_image.src) || imgs[x.id] || p.featured_image || (p.images && p.images[0] && p.images[0].src) || '';
out.push(card({ id: p.id + '-' + x.id, handle: p.handle + '?variant=' + x.id, title: p.title + ' · ' + x['option' + ci], options: p.options, price: p.price, compare_at_price: p.compare_at_price, variants: [x], featured_image: src, images: [] }, H0));
});
});
return out.join('');
}
function dkFix() {
[].forEach.call(document.querySelectorAll('.om__pick[data-k="cap"], [data-cart-recs]'), function (box) {
var h = box.querySelector('.cd__h'), row = box.querySelector('.rc-row');
if (!h || !row || box.querySelector('.dk-row') || box.__dk) return;
if (!/^\s*Add a cap/i.test(h.textContent)) return;
box.__dk = 1;
dkList().then(function (l) {
box.__dk = 0;
if (!l.length || box.querySelector('.dk-row') || !box.contains(row)) return;
var ids = l.map(function (p) { return String(p.id); });
[].forEach.call(row.querySelectorAll('.rc'), function (c) { if (ids.indexOf(c.getAttribute('data-rc')) > -1) c.parentNode.removeChild(c); });
var html = dkCards(l);
if (!html) return;
var w = document.createElement('div'); w.className = 'dk-row';
w.innerHTML = '<p class="cd__h"><span>Docker hats</span></p><div class="rc-row">' + html + '</div>';
box.appendChild(w);
});
});
}
if (window.MutationObserver) new MutationObserver(function () { clearTimeout(dkFix.t); dkFix.t = setTimeout(dkFix, 60); }).observe(document.documentElement, { childList: true, subtree: true });
window.NexOpts = { card: card, click: click, PAY: PAY, LOCK: LOCK };
})();